<template>
  <div data-testid="gameserver-index-head">
    <h1 v-if="headline" class="mb-6 uppercase">
      {{ headline }}
    </h1>

    <div
      v-if="description"
      class="text-mouse [&>*+*]:mt-3"
      v-html="md.render(description)"
    />
  </div>
</template>

<script setup lang="ts">
const md = useMarkdownIt();

defineProps<{
  headline?: string;
  description?: string;
}>();
</script>
